import { FacetValueCount, FacetValues, GeographyPointsFacetValue, ReplayAPI_GeographyPointsFacetValue } from '../../../types/Facet';
import { Field } from '../../../types/Field';
import GeographyPointsFacet from './GeographyPointsFacetPresentation';
import { FacetLogic, RenderFacetProps  } from './Types';

function createFilter(facetSelection: FacetValues<GeographyPointsFacetValue>, field: Field) {
    if (!facetSelection || !facetSelection.facetValues || facetSelection.facetValues.length === 0) {
        return '';
    }

    if( facetSelection.facetValues.length > 1) {
        throw new Error(`GeographyPointsFacet selection should only contain one value, but found ${facetSelection.facetValues.length} values.`);
    }

    let radiusInKm = facetSelection.facetValues[0].radius/ 1000;
    let filter = field.systemSettings.filterClause
        .replace('{{LONGITUDE}}', facetSelection.facetValues[0].longitude.toString())
        .replace('{{LATITUDE}}', facetSelection.facetValues[0].latitude.toString())
        .replace('{{OPERATOR}}', 'le')
        .replace('{{RADIUS}}', radiusInKm.toString());
    return filter;
}

function createRequest(field: Field) {    
    return field.name; //GeographyPointsFacet is not a real facet and can not be requested, so return empty string.
}

function extractFacetValues(facetName: string, facetValuesFromSearch: ReplayAPI_GeographyPointsFacetValue) : FacetValueCount<GeographyPointsFacetValue>[] {    
    //GeographyPointsFacet is not a real facet and can not be requested, therefore we also can not extract any value.
    return [];
}

function renderFacet (props: RenderFacetProps) {    
    const geoFacetValue = props.facetSelection?.facetValues.length ? props.facetSelection.facetValues[0] as GeographyPointsFacetValue : null;

    return <GeographyPointsFacet
             key={props.field.name} 
             name={props.field.name} 
             displayName={props.field.userSettings.displayName} 
             facetData={geoFacetValue} 
             facetSelection={props.facetSelection}
             onChangeFacet={props.onChangeFacetSelection}/>
}

// The facetValue contains the value of the entry that has been clicked.
// If this entry currently exists in the selection it will be removed else it will be added.
function createUpdatedSelection(facetValue: GeographyPointsFacetValue, prevFacetSelection: FacetValues<GeographyPointsFacetValue>): FacetValues<GeographyPointsFacetValue> {
    return {
        facetName: prevFacetSelection.facetName,
        facetValues: [facetValue],
    };
}

export const geographyPointsFacetLogic : FacetLogic = {
    dataType: 'Collection(Edm.GeographyPoint)',
    createFilter: createFilter,
    createRequest: createRequest,
    extractFacetValues: extractFacetValues,
    renderFacet: renderFacet,
    createUpdatedSelection: createUpdatedSelection,
}